import { createSlice } from "@reduxjs/toolkit";
import { deSelectedServices } from "@/enums/chart.enum";
import { getSelectedRangeType } from "@/pages/Power/helpers/PowerChart.helpers";
import type { YAxisRangeType } from "@/types/common/websockets.types";
import type {
  DisplayAsObject,
  SelectedOutputObj,
  SelectedRange,
} from "@/types/data/redux.types";
import { setLiveRange, setSelectedResource } from "./power.actions";
export const scheduleExchangeSliceName = "schedule";
type ScheduleExchangeState = {
  schedulesDataLoading: boolean;
  types: DisplayAsObject[];
  selectedResource: string;
  outputs: SelectedOutputObj[];
  selectedOutput: string | undefined;
  isZoomed: boolean;
  zoomRange: YAxisRangeType;
  inactiveLegends: string[];
  liveRange: Omit<SelectedRange, "type">;
  selectedRange: SelectedRange;
};

const initialState: ScheduleExchangeState = {
  schedulesDataLoading: true,
  types: [],
  selectedResource: "",
  outputs: [],
  selectedOutput: undefined,
  isZoomed: false,
  zoomRange: { min: 0, max: 0 },
  inactiveLegends: deSelectedServices,
  liveRange: { from: undefined, to: undefined },
  selectedRange: {
    from: undefined,
    to: undefined,
    type: getSelectedRangeType(),
  },
};

export const scheduleExchangeSlice = createSlice({
  name: scheduleExchangeSliceName,
  initialState,
  reducers: {
    setSchedulesDataLoading: (state, action) => {
      state.schedulesDataLoading = action.payload;
    },
    setTypes: (state, action) => {
      state.types = action.payload;
    },
    setOutputs: (state, action) => {
      state.outputs = action.payload;
    },
    setSelectedOutput: (state, action) => {
      state.selectedOutput = action.payload;
    },
    toggleZoom: (state, action) => {
      state.isZoomed = action.payload;
    },
    setZoomRange: (state, action) => {
      state.zoomRange = action.payload;
    },
    setSelectedRange: (state, action) => {
      state.selectedRange = action.payload;
    },
    toggleLegend: (state, action) => {
      if (state.inactiveLegends.includes(action.payload)) {
        state.inactiveLegends.splice(
          state.inactiveLegends.indexOf(action.payload),
          1
        );
      } else {
        state.inactiveLegends.push(action.payload);
      }
    },
  },
  // TODO: extraReducers are used here because these actions are defined in a separate file (power.actions.ts).
  // setSelectedResource is an over-engineered async thunk that should be simplified to a regular reducer action.
  // See power.actions.ts for details on the double websocket setup issue.
  extraReducers: (builder) => {
    builder.addCase(setSelectedResource.pending, (state) => {
      state.selectedResource = "";
    });
    builder.addCase(setSelectedResource.fulfilled, (state, action) => {
      state.selectedResource = action.payload;
    });
    builder.addCase(setLiveRange, (state, action) => {
      state.liveRange = action.payload;
    });
  },
});

export const {
  setSchedulesDataLoading,
  setTypes,
  setOutputs,
  setSelectedOutput,
  toggleZoom,
  setZoomRange,
  toggleLegend,
  setSelectedRange,
} = scheduleExchangeSlice.actions;

export default scheduleExchangeSlice;
